<template>
  <v-container :fluid="true" class="bg-light-beige ma-0 pa-0">
    <div class="page__title">
      Регистрация
    </div>
    <RegistrationLevel v-if="$route.name === names.REGISTRATION.PAGE"/>
    <router-view v-else />
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import RegistrationLevel from "@/modules/core/components/registration/RegistrationLevel.vue"
import pa_names from "@/modules/personal_account/routers/names"
import { mapGetters } from "vuex"

export default defineComponent({
  name: "Registration",
  components: { RegistrationLevel },
  computed: {
    pa_names () {
      return pa_names
    },
    names () {
      return names
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      getUserStatus: 'auth/getUserStatus',
    })
  },
  methods: {
    endRedirect () {
      if (window.scrollY !== 0) {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
      }
      this.$router.push({ name: pa_names.MAIN })
    },
  },
  created () {
    if (this.getUserStatus.approve && !this.getUserStatus.agreement) {
      this.$router.push({ name: pa_names.MAIN })
    }
  },
})
</script>

<style scoped lang="scss">
.page__title {
  margin-top: 30px;
  margin-bottom: 30px;
  font-style: normal;
  font-weight: 800;
  font-size: 75px;
  line-height: 84px;
  text-align: center;

  color: #3254B9;
}

@media screen and (max-width: 1920px) {
  .page__title {
    font-size: 65px;
    line-height: 74px;
  }
}

@media screen and (max-width: 1279px) {
  .page__title {
    font-size: 50px;
    line-height: 57px;
    padding: 0 40px;
  }
}

@media screen and (max-width: 768px) {
  .page__title {
    font-size: 30px;
    line-height: 37px;
    padding: 0 20px;
  }
}
</style>
